import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import http from '../middleware/http'
import relations from '../middleware/relations'
import rootReducer from '../reducers'
import async from '../middleware/async'
import heartbeat from '../middleware/heartbeat'

import obsoleteHttp from '../deconstructionCenter/obsoleteHttp.js'
import dashboardHttp from '../deconstructionCenter/dashboardHttp.js'
import cleanFactory from '../deconstructionCenter/cleanFactory.js'

export default function configureStore(initialState) {

	var _m;

	if ( window.devToolsExtension ) {
		_m = compose(
			    applyMiddleware(thunk, async, relations, heartbeat, http, dashboardHttp, obsoleteHttp, cleanFactory),
			    window.devToolsExtension()
			  )
	}else{
		_m = compose(
			    applyMiddleware(thunk, async, relations, heartbeat, http, dashboardHttp, obsoleteHttp, cleanFactory)
			  )
	}

  return createStore(
    rootReducer,
    initialState,
    _m
  )
}
